module.exports = __webpack_public_path__ + "static/img/7.9156623b.png";